<template>
  <v-container fluid>
    <v-row align="center">
      <v-col class="d-flex" cols="12" sm="6">
        <v-select  v-model="item"
          :items="items"
          label="Select an option"
           v-on:change="selectChange"
        ></v-select>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      items: [ '1.30', '1.31','1.32', '1.33','1.34', '1.35','1.36','1.37','1.38','1.39',
                '1.40', '1.41','1.42', '1.34','1.44', '1.45','1.46','1.47','1.48','1.49',
                '1.50', '1.51','1.52', '1.54','1.54', '1.55','1.56','1.57','1.58','1.59',
                '1.60', '1.61','162', '1.64','1.64', '1.65','1.66','1.67','1.68','1.69',
                '1.70', '1.71','1.72', '1.74','1.74', '1.75','1.76','1.77','1.78','1.79',
                '1.80', '1.81','1.82', '1.84','1.84', '1.85','1.86','1.87','1.88','1.89',
                '1.90', '1.91','1.92', '1.94','1.94', '1.95','1.96','1.97','1.98','1.99',
                '2.00', '2.01','2.02', '2.03','2.04', '2.05','2.06','2.07','2.08','2.09',
      ]
    }
    ),    methods: {
        selectChange: function(item){
            this.$emit('change', item)
        }
    }
  }
</script>